import { FC, ReactEventHandler, ReactNode, useEffect } from "react";
import classNames from "classnames";
import ClearBtn from "../ClearBtn/ClearBtn";
import { Headline } from "src/UI";
import type { HeadlineTypes } from "src/UI/Headline";
import "./Modal.scss";

export interface IBaseModalProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
	isOpen: boolean;
	onClose: ReactEventHandler;
	/** Закрывать ли модалку по нажатию Esc */
	closeOnEsc?: boolean;
};

interface ModalProps extends IBaseModalProps {
	children?: ReactNode,
	title?: string;
	titleType?: HeadlineTypes;
	className?: string;
	color?: "error" | "green" | "light" | string;

	isBlocked?: boolean;

	renderBody?: FC;
	renderIcon?: FC | ReactNode;
	renderFooter?: FC | ReactNode;
};

const Modal: FC<ModalProps> = (props) => {

	const { isOpen, title = "ReDoc",titleType = "large", isBlocked = true, className, color, onClose, children, renderIcon, renderFooter, renderBody, closeOnEsc = true } = props;

	const onCloseHandler: ReactEventHandler = (e) => onClose(e);

	if ( !isOpen )
		return null;

	// Закрытие по Esc
	useEffect( () => {
		if ( !closeOnEsc ) return;
		const handleKeyDown = ( e: KeyboardEvent ) => {
			if ( e.key === "Escape" ) onCloseHandler(e as unknown as any);
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, [ closeOnEsc ] );

	const modalClasses = classNames( "rdc_modal", className, color);

	const renderWrapper = ( props: any ) => {
		if ( !!renderBody )
			return (
				<div className="rdc_modal__content__wrapper">
					{ renderBody(props) }
				</div>
			);
		return <div className="rdc_modal__content__text body-large">{children}</div>;
	};

	const renderModal = () => (
		<div className={modalClasses} onClick={(e) => e.stopPropagation()}>
			<div className="rdc_modal__header">
				<Headline type={titleType} className="rdc_modal__header__title">{title}</Headline>
				<ClearBtn notHint className="rdc_modal__header__close_btn" onClick={onCloseHandler} />
			</div>
			<div className="rdc_modal__content">
				{
					!!renderIcon &&
					<div className="rdc_modal__content__icon">
						{ typeof renderIcon === "function" ? renderIcon(props) : renderIcon }
					</div>
				}
				{ renderWrapper(props) }
			</div>
			{
				!!renderFooter && 
				<div className="rdc_modal__footer">
					{ typeof renderFooter === "function" ? renderFooter(props) : renderFooter }
				</div>
			}
		</div>
	);

	return (
		<div className={classNames("rdc_blocked__wrapper", { 'blocked': isBlocked } )} onClick={onCloseHandler}>
			{renderModal()}
		</div>
	);
};

export default Modal;
